import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ChevronRight } from "lucide-react";
import { api } from "../lib/api";
import { fmtQty, stockTone } from "../lib/stock";

export const LowStockCard = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/stock/low").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);
  if (!rows || rows.length === 0) return null;
  return (
    <div className="rounded-xl border border-[color:var(--primary)]/30 bg-white p-5 ink-shadow" data-testid="low-stock-card">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <span className="h-9 w-9 rounded-lg flex items-center justify-center bg-[color:var(--primary)]/10 text-[color:var(--primary)]">
            <AlertTriangle className="h-4 w-4" />
          </span>
          <div>
            <p className="overline text-[color:var(--muted)]">Stock alert</p>
            <h3 className="font-display text-lg font-bold" data-testid="low-stock-count">{rows.length} products low on stock</h3>
          </div>
        </div>
        <Link to="/admin/products" className="text-sm font-semibold text-[color:var(--primary)] flex items-center hover:underline" data-testid="low-stock-manage-link">
          Manage <ChevronRight className="h-4 w-4" />
        </Link>
      </div>
      <div className="flex flex-wrap gap-2">
        {rows.slice(0, 12).map((p) => (
          <span key={p.id} className={`text-xs px-2.5 py-1 rounded-full font-semibold font-tamil ${stockTone(p)}`} data-testid={`low-stock-item-${p.id}`}>
            {p.name} · {fmtQty(p.stock_qty)}
          </span>
        ))}
        {rows.length > 12 && <span className="text-xs text-[color:var(--muted)] self-center">+{rows.length - 12} more</span>}
      </div>
    </div>
  );
};

export default LowStockCard;
